module.exports = __webpack_public_path__ + "img/new_logo.618f01ff.png";